import { useState } from "react";
import PublicHeader from "@/components/PublicHeader";
import SiteFooter from "@/components/SiteFooter";
import { useSeo, ORG_LD, crumbs, SITE } from "@/lib/seo";

const OFFERS = [["Free", "0"], ["Professional", "14.99"], ["Career Pro", "29.99"], ["Executive Elite", "49.99"], ["Recruiter Starter", "245"], ["Recruiter Growth", "469"], ["Recruiter Agency Pro", "855"]];
const PRICING_LD = [ORG_LD, crumbs([["Home", "/"], ["Pricing", "/pricing"]]), { "@type": "Product", name: "JobPedestal", description: "Career platform with verified employer-direct jobs, explainable fit scores and AI career assistants.", brand: { "@type": "Brand", name: "JobPedestal" },
  offers: OFFERS.map(([n, p]) => ({ "@type": "Offer", name: n, price: p, priceCurrency: "USD", url: `${SITE}/pricing` })) }];
import { PlanGrid } from "@/components/Plans";

export default function Pricing() {
  const [aud, setAud] = useState("candidate");
  useSeo({ title: "Pricing — candidate and recruiter plans", path: "/pricing", jsonLd: PRICING_LD,
    description: "JobPedestal pricing: free candidate plan, Professional $14.99, Career Pro $29.99 and Executive Elite $49.99 per month; recruiter plans from $245 per month, $4.94 per candidate unlock, plus custom Enterprise." });
  return (
    <div className="min-h-screen">
      <PublicHeader />
      <main className="mx-auto max-w-7xl px-4 py-16 sm:px-8">
        <p className="eyebrow mb-3">Pricing</p>
        <h1 className="text-4xl font-extrabold sm:text-5xl" data-testid="pricing-title">Simple monthly plans.</h1>
        <p className="mt-4 max-w-xl text-slate-600">Cancel any time. AI usage is metered with clear monthly credits — no surprise overages.</p>
        <div className="mt-10 inline-flex rounded-full border bg-white p-1" role="tablist">
          {["candidate", "recruiter"].map((a) => (
            <button key={a} role="tab" aria-selected={aud === a} data-testid={`pricing-tab-${a}`} onClick={() => setAud(a)}
              className={`rounded-full px-5 py-2 text-sm font-semibold capitalize transition-colors ${aud === a ? "bg-[hsl(var(--obsidian))] text-white" : "text-slate-600 hover:text-slate-900"}`}>{a}s</button>
          ))}
        </div>
        <div className="mt-10"><PlanGrid audience={aud} /></div>
        {aud === "recruiter" && <p className="mt-6 rounded-2xl border bg-white p-4 text-sm text-slate-700" data-testid="pricing-unlock-note"><span className="font-semibold">No plan? Pay $4.94 per candidate.</span> Unlock a contact request to any opted-in candidate with a one-time card payment. Contact details are shared only if the candidate accepts.</p>}
        <p className="mt-8 text-xs text-slate-500">Payments are processed by Stripe. Prices in USD, taxes may apply at checkout.</p>
      </main>
      <SiteFooter />
    </div>
  );
}
